import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';

export default class NotificationlDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      scroll: 'paper',
    };
  }

  // FIXME: do refresh the HTML properly
  componentDidMount() {
    setTimeout(() => {
      this.props.onRefreshDialog();
    }, 1000);
  }

  render() {
    let html = this.props.html || '';
    return (
      <div>
        <Dialog
          open={this.props.isOpened}
          onClose={this.props.onCloseDialog}
          scroll={this.state.scroll}
          aria-labelledby="scroll-dialog-title"
        >
          <DialogTitle id="scroll-dialog-title">Notification Preview</DialogTitle>
          <DialogContent dividers={this.state.scroll === 'paper'}>
            <TextField
              autoFocus
              id="message"
              label="Message"
              type="text"
              fullWidth
              style={{
                marginBottom: '1em',
              }}
              onChange={(e) => this.props.onUpdateNotificationTextFunc(e.target.value)}
            />
            <DialogContentText>
              <div dangerouslySetInnerHTML={{ __html: html }}></div>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.props.onRefreshDialog} color="primary">
              Preview
            </Button>
            <Button onClick={this.props.onCloseDialog} color="primary">
              Cancel
            </Button>
            <Button onClick={this.props.onPressedSubmit} color="primary">
              Send
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
